import React from 'react';
/**
 * Layout component for rendering two columns side-by-side, with one column
 * allowed to take the full remaining width of the container.
 *
 * Scroll behavior can be controlled independently for each column.
 *
 * @param {LayoutColumns2Props} props - The props for the layout component.
 * @param {React.ReactNode} [props.column1] - Optional content for the first column.
 * @param {React.ReactNode} [props.column2] - Optional content for the second column.
 * @param {'column1' | 'column2'} props.fullWidthColumn - Specifies which column should occupy remaining space.
 * @param {boolean} [props.column1Scrollable] - Enables scroll for column 1 if set to true.
 * @param {boolean} [props.column2Scrollable] - Enables scroll for column 2 if set to true.
 * @param {string} [props.data-test] - Optional `data-test` attribute for testing.
 * @returns {JSX.Element} Rendered two-column layout element.
 */
export const LayoutColumns2 = (props) => {
    const fwc = props.fullWidthColumn;
    return (React.createElement("div", { style: {
            display: 'grid',
            width: '100%',
            height: '100%',
            gridTemplateColumns: size(fwc === 'column1') + ' ' + size(fwc === 'column2'),
        }, "data-test": props['data-test'] },
        React.createElement("div", { style: { overflow: props.column1Scrollable ? 'auto' : 'hidden', gridColumn: '1/2' }, "data-test": 'column1' }, props.column1 && props.column1),
        React.createElement("div", { style: { overflow: props.column2Scrollable ? 'auto' : 'hidden', gridColumn: '2/3' }, "data-test": 'column2' }, props.column2 && props.column2)));
};
function size(full) {
    return full ? '1fr' : 'auto';
}
